import React from 'react'
import './nav.css'
import Logo from '../../Images/Larger devices/Bella.png'

function Nav() {
  return (
    <div className='body'>
      <nav className="navbar navbar-expand-lg navbar-light bg-transparent">
      <a className="navbar-brand" href="#"><img src={Logo} alt='' /></a>
      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav ml-auto">
      <li className="nav-item active">
        <a className="nav-link red jock" href="#">Home <span className="sr-only">(current)</span></a>
      </li>
      <li className="nav-item active">
        <a className="nav-link jock" href="#">Product <span className="sr-only">(current)</span></a>
      </li>
      <li className="nav-item active">
        <a className="nav-link jock" href="#">FaQ <span className="sr-only">(current)</span></a>
      </li>
      <li className="nav-item active">
        <a className="nav-link str" href="#">Contact <span className="sr-only">(current)</span></a>
      </li>
      </ul>
      </div>
      </nav>
    </div>
  )
}

export default Nav